import { StanButton, StanModal } from '@/components';
import { createIconElement } from '@/lib/utils/createIconElement';
import { formatTimeTo12Hour, parseLocalDate } from '@/lib/utils/timeUtils';
import IcCalendar from '@/assets/icons/ic-calendar.svg';
import IcClock from '@/assets/icons/ic-clock.svg';

const CalendarIcon = createIconElement(IcCalendar, { className: 'size-5' });
const ClockIcon = createIconElement(IcClock, { className: 'size-5' });

interface BlockedTimeDetailsModalProps {
    isOpen: boolean;
    onClose: () => void;
    blockedTime: {
        id: string;
        startDate: string;
        endDate: string;
        startTime: string;
        endTime: string;
    };
    onEdit: () => void;
    onDelete: () => void;
}

export function BlockedTimeDetailsModal({
    isOpen,
    onClose,
    blockedTime,
    onEdit,
    onDelete,
}: BlockedTimeDetailsModalProps) {
    const formatDate = (dateString: string) => {
        const date = parseLocalDate(dateString);
        return date.toLocaleDateString('en-US', {
            weekday: 'long',
            month: 'short',
            day: 'numeric',
            year: 'numeric',
        });
    };

    return (
        <StanModal id='blocked-time-details-modal' isOpen={isOpen} onClose={onClose} title='Block Time' size='sm'>
            <div className='space-y-8'>
                <div className='flex gap-8'>
                    <div className='flex-1 space-y-3'>
                        <h5 className='text-secondary text-body-xs'>Starting</h5>
                        <div className='space-y-2'>
                            <div className='flex items-center gap-3'>
                                {CalendarIcon}
                                <span className='text-dark text-body-xs'>{formatDate(blockedTime.startDate)}</span>
                            </div>
                            <div className='flex items-center gap-3'>
                                {ClockIcon}
                                <span className='text-dark text-body-xs'>
                                    {formatTimeTo12Hour(blockedTime.startTime)}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className='flex-1 space-y-3'>
                        <h5 className='text-secondary text-body-xs'>Ending</h5>
                        <div className='space-y-2'>
                            <div className='flex items-center gap-3'>
                                {CalendarIcon}
                                <span className='text-dark text-body-xs'>{formatDate(blockedTime.endDate)}</span>
                            </div>
                            <div className='flex items-center gap-3'>
                                {ClockIcon}
                                <span className='text-dark text-body-xs'>
                                    {formatTimeTo12Hour(blockedTime.endTime)}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='flex gap-3 pt-4'>
                    <StanButton
                        name='delete-block-time'
                        onClick={onDelete}
                        variant='ghost'
                        color='destructive'
                        className='flex-1'
                    >
                        Delete
                    </StanButton>
                    <StanButton name='edit-block-time' onClick={onEdit} color='primary' className='flex-1'>
                        Edit
                    </StanButton>
                </div>
            </div>
        </StanModal>
    );
}
